<template>
  <form @submit.prevent="submit" class="input">
    <label class="input-label">
      <input
        v-if="input.type === 'text'"
        class="quick"
        type="text"
        v-model="value"
        :placeholder="input.placeholder || ''"
        @input="specials"
      />
      <input
        v-else-if="input.type === 'range'"
        class="quick"
        type="range"
        v-model="value"
        :placeholder="input.placeholder || ''"
      />
      <input
        v-else-if="input.type === 'number'"
        class="quick"
        type="number"
        v-model="value"
        :placeholder="input.placeholder || ''"
        :min="input.min"
        max="122"
        :step="input.step"
        style="min-width: 200px;"
        pattern="\d*"
        @input="negative"
      />
      <Slider
        v-else-if="input.type === 'slider'"
        v-model="value"
        :input="input"
        :disabled="!focus"
      />
      <AgeSlider
        v-else-if="input.type === 'ageSlider'"
        v-model="value"
        :input="input"
        :disabled="!focus"
      />
      <textarea
        v-else-if="input.type === 'textarea'"
        class="quick textarea"
        v-model="value"
        :input="input"
        :disabled="!focus"
        :placeholder="input.placeholder || ''"
      />
      <Score
        v-else-if="input.type === 'score'"
        v-model="value"
        :input="input"
      />
      <BudgetSelect 
        v-else-if="input.type === 'budget'"
        v-model="value"
        :input="input"
      />
    </label>
    <button
      class="quick has-icon"
      type="submit"
      v-if="focus"
      :style="{ color: submitColor }"
      v-bind="attribute"
    >
      <icon
        class="quick-icon"
        name="arrow-right-bold"
        :bg="submitColor"
        fill="white"
      />
      {{ input.submit || 'ok' }}
    </button>

    <button
      class="quick has-icon"
      @click="skip"
      v-if="focus && input.skip"
      :style="{ color: '#005ba9' }"
      v-bind="attribute"
    >
      <icon
        class="quick-icon"
        name="arrow-right-bold"
        bg="#005ba9"
        fill="white"
      />
      {{ $root.__('skip') }}
    </button>

    <button
      class="quick has-icon"
      @click="edit"
      v-if="focus && input.edit"
      :style="{ color: '#005ba9' }"
      v-bind="attribute"
    >
      <icon
        class="quick-icon"
        name="pencil"
        bg="#31aee9"
        fill="white"
      />
      {{ $root.__('edit choices') }}
    </button>
  </form>
</template>

<script>
import { chat } from '../chat.js'
import Score from './Score.vue'
import Slider from './Slider.vue'
import AgeSlider from './AgeSlider.vue'
import BudgetSelect from './BudgetSelect.vue'

export default {
  components: {
    AgeSlider,
    Score,
    Slider,
    BudgetSelect
  },
  props: {
    focus: null,
    input: null,
    next: null
  },
  data() {
    let value = this.input.value || ''
    if (this.$root.state[this.input.model]) {
      value = this.$root.state[this.input.model]
    }
    if (this.input.type === 'number') {
      value = parseInt(value) || ''
      if (isNaN(value) || value < this.input.min || value > this.input.max) {
        value = ''
      }
    }
    if (value === this.$root.__('name alternative')) {
      value = ''
    }
    return {
      submitColor: '#999',
      value
    }
  },
  computed: {
    attribute() {
      return this.input.model
        ? {
            ['data-choice-' + this.input.model]: this.value
          }
        : {}
    }
  },
  methods: {
    negative() {
      if (this.value < 0) {
        this.value = -this.value
      }
    },
    specials() {
      if (this.input.model === 'name') {
        this.value = this.value
          .replace(/[#@&"'()!*$€£%`≠=+:/;?,§<>\[\]{}0-9]/g, ' ')
          .replace(/\s+/g, ' ')
          .replace(/^\s+/, '')
      }
    },
    submit() {
      let value =
        this.value !== this.input.value ? this.value : this.input.alternative
      if (this.input.type === 'slider') {
        return chat.send({
          text: this.input.submit,
          next: this.input.next || this.next,
          data: {
            [this.input.model]: value || this.value
          }
        })
      }
      let text = this.input.textual
        ? value !== -1
          ? this.input.textual.replace('#', value)
          : this.input.submit
        : String(value)
      if (this.input.type === 'number') {
        value = parseInt(value)
        text = String(value)
        if (isNaN(value)) {
          value = this.input.alternative
          text = this.input.alternativeText
        }
      }
      if (this.input.type === 'score') {
        this.$root.track({
          event_type: 'user_interaction',
          page_type: "dreambuddy",
          interaction_type: 'submit_review',
          score: value,
        })
      }
      console.log('submit', this.input, value)
      chat.send({
        text: text,
        next: this.input.next || this.next,
        data: {
          [this.input.model]: value
        }
      })
    },
    skip() {
      chat.send({
        text: this.input.skip.text,
        next: this.input.skip.next,
        data: {
          [this.input.model]: '-'
        }
      })
    },
    edit() {
      chat.send({
        text: this.input.edit.text,
        next: this.input.edit.next,
        data: {
          [this.input.model]: '-'
        }
      })
    }
  },
  mounted() {
    const elem = this.$el.querySelector('input')
    elem && elem.focus()
  },
  watch: {
    value(val, old) {
      if (this.submitColor === '#999' && val !== old) {
        this.submitColor = '#005ba9'
      }
    }
  }
}
</script>

<style>
.input {
  margin: 0 -0.5em;
}
.input-label {
  display: block;
}
.textarea {
  display: block;
  width: calc(100% - 1em);
  box-sizing: border-box;
  border-radius: 23px;
}
</style>
